import React, { useRef, useState } from 'react';
import { FaTrash } from 'react-icons/fa';
import './ConsultationTrashButton.css';

// The module's existing remove callback owns confirmation, API errors and refresh.
export default function ConsultationTrashButton({ row, onRemove, disabled = false }) {
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  if (!onRemove) return null;
  const label = `Excluir cadastro de ${row.fullName || row.socialName || 'aluno/atendido'}`;
  const remove = async (event) => {
    event.stopPropagation();
    if (disabled || pending.current) return;
    pending.current = true;
    setBusy(true);
    try { await onRemove(row.id); }
    finally { pending.current = false; setBusy(false); }
  };
  return <span style={{ display: 'inline-flex' }} onClick={event => event.stopPropagation()} onDoubleClick={event => event.stopPropagation()}><button type="button" className="consultation-trash-button" title={label} aria-label={label} aria-busy={busy} disabled={disabled || busy} onClick={remove} onDoubleClick={event => event.stopPropagation()}><FaTrash aria-hidden="true" /></button></span>;
}
